import type { SchemaChatResolver_GetChats } from 'cpool-tables/backend-resolvers';

import { isSenderNumberUnavailable } from '~/features/whatsapp/utils/isSenderNumberUnavailable';

type MessageSample = Parameters<typeof isSenderNumberUnavailable>[0];

export const resolveSenderUnavailable = ({
    chat,
    messages,
}: {
    chat: Pick<SchemaChatResolver_GetChats[number], 'phoneNumberUnavailable'> | undefined;
    messages: MessageSample;
}): boolean => Boolean(chat?.phoneNumberUnavailable) || isSenderNumberUnavailable(messages);
